import { html, LitElement, css } from 'lit';
import { TWStyles } from '../styles/tw.js';
import splashFooter from './partials/splash-footer.js';
import '@digital-realty/ix-button/ix-button.js';

export class IxSessionExpiry extends LitElement {
  static styles = [
    TWStyles,
    css`
      :host {
        --md-filled-button-container-shape: 0;
      }

      #wrapper {
        background: url('/assets/images/login-background.jpg') center/cover;
        height: 100vh;
        width: 100vw;
      }
    `,
  ];

  render() {
    return html`<main id="wrapper" class="flex flex-col text-center">
      <div class="grow flex">
        <div class="bg-white w-[404px] p-6 m-auto">
          <div class="pb-6 border-b border-[rgba(9,34,65,.12)]">
            <img
              class="m-auto"
              src="/assets/images/dlr-brandmark-narrow-black.png"
              alt="Digital Realty"
            />
          </div>
          <p class="dlr-text-heading my-6">
            You have been logged out of the Global Portal due to inactivity.
          </p>
          <div>
            <ix-button href="/">Log in</ix-button>
          </div>
        </div>
      </div>
      ${splashFooter}
    </main>`;
  }
}

window.customElements.define('ix-session-expiry', IxSessionExpiry);
